import { useEffect, useState } from "react";
import { useAuth } from "../utils/AuthContext";


export const useDoctorRole = () => {
 const [isAdmin, setIsAdmin] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const { user, loading } = useAuth();
  const [isDoctor, setIsDoctor] = useState(false);
  const [doctorLoading, setDoctorLoading] = useState(true);

useEffect(() => {
  // console.log("useDoctorRole User:", user);
  if (!loading) {
    if (user) {
      setIsDoctor(user.role === "doctor");
      setIsAdmin(user.role === "admin");
      setIsSuperAdmin(user.role === "superadmin");
    } else {
      setIsDoctor(false);
      setIsAdmin(false);
      setIsSuperAdmin(false);
    }
    setDoctorLoading(false);
  }
}, [user, loading]);

  return { isDoctor, isAdmin, isSuperAdmin, isLoading: loading || doctorLoading };
};